module.exports = __webpack_public_path__ + "static/media/WhatsApp-Image-2022-07-29-at-10.35.06-AM.337b4039.jpeg";